/**
 * @generated SignedSource<<966ec247267f71b995d95274a1e8ee21>>
 * @relayHash 467ccb6d16fbfc35aca2438436e2fad1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e74730fbfcc5990380e6c6b3d0357d52aa013735bea41f6b563c2e4701298a83

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type SpaceSidebarLinkType = "EXTERNAL_LINK" | "FORGE" | "PINNED_ATTACHMENT" | "PINNED_BLOG_POST" | "PINNED_PAGE" | "PINNED_SPACE" | "PINNED_USER_INFO" | "WEB_ITEM" | "%future added value";
export type SpaceNavigationQuery$variables = {
  contentId?: string | null;
  includeHomepageTreeVariant?: boolean | null;
  includePageTree?: boolean | null;
  isLicensed: boolean;
  isSuperAdmin?: boolean | null;
  paginationLimit?: number | null;
  ptStatuses?: ReadonlyArray<PTGraphQLPageStatus | null> | null;
  spaceKey?: string | null;
};
export type SpaceNavigationQuery$data = {
  readonly currentPage?: {
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly nearestAncestors: {
      readonly nodes: ReadonlyArray<{
        readonly followingSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
          } | null> | null;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null;
        } | null;
        readonly previousSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
          } | null> | null;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly previousSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
  } | null;
  readonly homepageRootPageTree?: {
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
  } | null;
  readonly rootPageTree?: {
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
  } | null;
  readonly space: {
    readonly containsExternalCollaborators: boolean;
    readonly currentUser?: {
      readonly isAdmin: boolean;
      readonly isFavourited: boolean;
      readonly isWatched: boolean;
    };
    readonly didContainUserContent: boolean;
    readonly history: {
      readonly createdDate: string | null;
    } | null;
    readonly homepage: {
      readonly id: string | null;
    } | null;
    readonly homepageId: string | null;
    readonly icon: {
      readonly path: string;
    } | null;
    readonly id: string | null;
    readonly key: string | null;
    readonly name: string | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
    readonly pageTree?: {
      readonly children: {
        readonly nodes: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly followingSiblings: {
        readonly nodes: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly nearestAncestors: {
        readonly nodes: ReadonlyArray<{
          readonly followingSiblings: {
            readonly nodes: ReadonlyArray<{
              readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
            } | null> | null;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            } | null;
          } | null;
          readonly previousSiblings: {
            readonly nodes: ReadonlyArray<{
              readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
            } | null> | null;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            } | null;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly endCursor: string | null;
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly previousSiblings: {
        readonly nodes: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
    } | null;
    readonly status: string | null;
    readonly type: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"SpaceHeader_space" | "SpaceOperationsFragment">;
  } | null;
  readonly spaceSidebarLinks: {
    readonly main: ReadonlyArray<{
      readonly canHide: boolean | null;
      readonly hidden: boolean;
      readonly icon: {
        readonly height: number | null;
        readonly isDefault: boolean | null;
        readonly path: string;
        readonly width: number | null;
      } | null;
      readonly iconClass: string | null;
      readonly id: string;
      readonly linkIdentifier: string | null;
      readonly position: number;
      readonly styleClass: string | null;
      readonly title: string | null;
      readonly tooltip: string | null;
      readonly type: SpaceSidebarLinkType;
      readonly url: string | null;
      readonly webItemCompleteKey: string | null;
      readonly webItemKey: string | null;
    } | null> | null;
    readonly quick: ReadonlyArray<{
      readonly id: string;
      readonly position: number;
      readonly styleClass: string | null;
      readonly title: string | null;
      readonly url: string | null;
    } | null> | null;
  } | null;
  readonly user: {
    readonly confluence: {
      readonly permissionType: SitePermissionType | null;
    } | null;
    readonly id: string | null;
  } | null;
};
export type SpaceNavigationQuery = {
  response: SpaceNavigationQuery$data;
  variables: SpaceNavigationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeHomepageTreeVariant"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePageTree"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLicensed"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSuperAdmin"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paginationLimit"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ptStatuses"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "alias": "user",
  "args": [
    {
      "kind": "Literal",
      "name": "current",
      "value": true
    }
  ],
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "confluence_atlassianUser",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "concreteType": "ConfluenceUser",
      "kind": "LinkedField",
      "name": "confluence",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "permissionType"
        }
      ]
    }
  ],
  "storageKey": "confluence_atlassianUser(current:true)"
},
v10 = {
  "kind": "Variable",
  "name": "spaceKey",
  "variableName": "spaceKey"
},
v11 = {
  "kind": "ScalarField",
  "name": "position"
},
v12 = {
  "kind": "ScalarField",
  "name": "title"
},
v13 = {
  "kind": "ScalarField",
  "name": "url"
},
v14 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v15 = {
  "kind": "ScalarField",
  "name": "path"
},
v16 = {
  "kind": "ScalarField",
  "name": "type"
},
v17 = {
  "args": [
    (v10/*: any*/)
  ],
  "concreteType": "SpaceSidebarLinks",
  "kind": "LinkedField",
  "name": "spaceSidebarLinks",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "includeHidden",
          "value": true
        }
      ],
      "concreteType": "SpaceSidebarLink",
      "kind": "LinkedField",
      "name": "main",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        {
          "kind": "ScalarField",
          "name": "webItemCompleteKey"
        },
        (v11/*: any*/),
        {
          "kind": "ScalarField",
          "name": "hidden"
        },
        {
          "kind": "ScalarField",
          "name": "webItemKey"
        },
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        {
          "concreteType": "Icon",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": [
            (v15/*: any*/),
            {
              "kind": "ScalarField",
              "name": "width"
            },
            {
              "kind": "ScalarField",
              "name": "height"
            },
            {
              "kind": "ScalarField",
              "name": "isDefault"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "iconClass"
        },
        {
          "kind": "ScalarField",
          "name": "canHide"
        },
        {
          "kind": "ScalarField",
          "name": "tooltip"
        },
        {
          "kind": "ScalarField",
          "name": "linkIdentifier"
        },
        (v16/*: any*/)
      ],
      "storageKey": "main(includeHidden:true)"
    },
    {
      "concreteType": "SpaceSidebarLink",
      "kind": "LinkedField",
      "name": "quick",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        (v13/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v14/*: any*/)
      ]
    }
  ]
},
v18 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v19 = {
  "kind": "ScalarField",
  "name": "key"
},
v20 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "homepage",
  "plural": false,
  "selections": [
    (v8/*: any*/)
  ]
},
v21 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "didContainUserContent"
},
v23 = {
  "kind": "ScalarField",
  "name": "name"
},
v24 = {
  "kind": "ScalarField",
  "name": "status"
},
v25 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v15/*: any*/)
  ]
},
v26 = {
  "kind": "ScalarField",
  "name": "homepageId"
},
v27 = {
  "condition": "isLicensed",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "SpaceUserMetadata",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAdmin"
        },
        {
          "kind": "ScalarField",
          "name": "isFavourited"
        },
        {
          "kind": "ScalarField",
          "name": "isWatched"
        }
      ]
    }
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "containsExternalCollaborators"
},
v29 = {
  "concreteType": "SpaceHistory",
  "kind": "LinkedField",
  "name": "history",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "createdDate"
    }
  ]
},
v30 = {
  "kind": "Literal",
  "name": "enablePaging",
  "value": true
},
v31 = {
  "kind": "Variable",
  "name": "pageTree",
  "variableName": "paginationLimit"
},
v32 = {
  "kind": "Variable",
  "name": "status",
  "variableName": "ptStatuses"
},
v33 = [
  (v30/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/)
],
v34 = {
  "kind": "FragmentSpread",
  "name": "PageTreeQuery_ptpage"
},
v35 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v36 = {
  "concreteType": "PTPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v35/*: any*/),
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v37 = {
  "concreteType": "PTPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v35/*: any*/)
  ]
},
v38 = [
  {
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v34/*: any*/)
    ]
  },
  (v37/*: any*/)
],
v39 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "previousSiblings",
  "plural": false,
  "selections": (v38/*: any*/)
},
v40 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "followingSiblings",
  "plural": false,
  "selections": (v38/*: any*/)
},
v41 = [
  (v34/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "nearestAncestors",
    "plural": false,
    "selections": [
      (v36/*: any*/),
      {
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v34/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/)
        ]
      }
    ]
  },
  (v39/*: any*/),
  (v40/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "children",
    "plural": false,
    "selections": (v38/*: any*/)
  }
],
v42 = [
  (v30/*: any*/),
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  },
  (v31/*: any*/),
  (v10/*: any*/),
  (v32/*: any*/)
],
v43 = [
  (v30/*: any*/),
  (v31/*: any*/),
  (v10/*: any*/),
  (v32/*: any*/)
],
v44 = [
  (v34/*: any*/),
  (v40/*: any*/)
],
v45 = [
  (v10/*: any*/),
  (v32/*: any*/)
],
v46 = {
  "kind": "ScalarField",
  "name": "value"
},
v47 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "MILLIS"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdDate",
  "plural": false,
  "selections": [
    (v46/*: any*/)
  ],
  "storageKey": "createdDate(format:\"MILLIS\")"
},
v48 = {
  "kind": "ScalarField",
  "name": "hasChildren"
},
v49 = {
  "kind": "ScalarField",
  "name": "blank"
},
v50 = {
  "condition": "isSuperAdmin",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "hasInheritedRestrictions"
    }
  ]
},
v51 = {
  "kind": "ScalarField",
  "name": "subType"
},
v52 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v53 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published",
        "emoji-title-draft",
        "editor"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        (v19/*: any*/),
        (v46/*: any*/),
        {
          "concreteType": "Version",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "number"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
},
v54 = [
  {
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v8/*: any*/),
      (v12/*: any*/),
      (v24/*: any*/),
      (v47/*: any*/),
      (v48/*: any*/),
      (v49/*: any*/),
      (v50/*: any*/),
      (v16/*: any*/),
      (v51/*: any*/),
      (v52/*: any*/),
      (v53/*: any*/)
    ]
  },
  (v37/*: any*/)
],
v55 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "previousSiblings",
  "plural": false,
  "selections": (v54/*: any*/)
},
v56 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "followingSiblings",
  "plural": false,
  "selections": (v54/*: any*/)
},
v57 = [
  (v8/*: any*/),
  (v12/*: any*/),
  (v24/*: any*/),
  (v47/*: any*/),
  (v48/*: any*/),
  (v49/*: any*/),
  (v50/*: any*/),
  (v16/*: any*/),
  (v51/*: any*/),
  (v52/*: any*/),
  (v53/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "nearestAncestors",
    "plural": false,
    "selections": [
      (v36/*: any*/),
      {
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v8/*: any*/),
          (v12/*: any*/),
          (v24/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/),
          (v49/*: any*/),
          (v50/*: any*/),
          (v16/*: any*/),
          (v51/*: any*/),
          (v52/*: any*/),
          (v53/*: any*/),
          (v55/*: any*/),
          (v56/*: any*/)
        ]
      }
    ]
  },
  (v55/*: any*/),
  (v56/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "children",
    "plural": false,
    "selections": (v54/*: any*/)
  }
],
v58 = [
  (v8/*: any*/),
  (v12/*: any*/),
  (v24/*: any*/),
  (v47/*: any*/),
  (v48/*: any*/),
  (v49/*: any*/),
  (v50/*: any*/),
  (v16/*: any*/),
  (v51/*: any*/),
  (v52/*: any*/),
  (v53/*: any*/),
  (v56/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SpaceNavigationQuery",
    "selections": [
      (v9/*: any*/),
      (v17/*: any*/),
      {
        "args": (v18/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "isLicensed",
                "variableName": "isLicensed"
              }
            ],
            "kind": "FragmentSpread",
            "name": "SpaceHeader_space"
          },
          (v8/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "SpaceOperationsFragment"
          },
          (v22/*: any*/),
          (v23/*: any*/),
          (v16/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          {
            "condition": "includeHomepageTreeVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v33/*: any*/),
                "concreteType": "PTPage",
                "kind": "LinkedField",
                "name": "pageTree",
                "plural": false,
                "selections": (v41/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "condition": "includePageTree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "currentPage",
            "args": (v42/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v41/*: any*/)
          },
          {
            "alias": "rootPageTree",
            "args": (v43/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v44/*: any*/)
          }
        ]
      },
      {
        "condition": "includeHomepageTreeVariant",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "homepageRootPageTree",
            "args": (v45/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v44/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SpaceNavigationQuery",
    "selections": [
      (v9/*: any*/),
      (v17/*: any*/),
      {
        "args": (v18/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v19/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v20/*: any*/),
          (v27/*: any*/),
          (v21/*: any*/),
          (v28/*: any*/),
          (v22/*: any*/),
          (v16/*: any*/),
          (v26/*: any*/),
          (v29/*: any*/),
          {
            "condition": "includeHomepageTreeVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v33/*: any*/),
                "concreteType": "PTPage",
                "kind": "LinkedField",
                "name": "pageTree",
                "plural": false,
                "selections": (v57/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "condition": "includePageTree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "currentPage",
            "args": (v42/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v57/*: any*/)
          },
          {
            "alias": "rootPageTree",
            "args": (v43/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v58/*: any*/)
          }
        ]
      },
      {
        "condition": "includeHomepageTreeVariant",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "homepageRootPageTree",
            "args": (v45/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v58/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "467ccb6d16fbfc35aca2438436e2fad1",
    "id": "e74730fbfcc5990380e6c6b3d0357d52aa013735bea41f6b563c2e4701298a83",
    "metadata": {},
    "name": "SpaceNavigationQuery",
    "operationKind": "query",
    "text": "query SpaceNavigationQuery($spaceKey:String,$isLicensed:Boolean!,$contentId:ID,$ptStatuses:[PTGraphQLPageStatus],$paginationLimit:Int,$isSuperAdmin:Boolean=false,$includePageTree:Boolean=false,$includeHomepageTreeVariant:Boolean=false){user:confluence_atlassianUser(current:true){id,confluence{permissionType}},spaceSidebarLinks(spaceKey:$spaceKey){main(includeHidden:true){id,webItemCompleteKey,position,hidden,webItemKey,title,url,styleClass,icon{path,width,height,isDefault},iconClass,canHide,tooltip,linkIdentifier,type},quick{id,url,position,title,styleClass}},space(key:$spaceKey){...SpaceHeader_space_3F1fcg,id,key,homepage{id},operations{operation,targetType},...SpaceOperationsFragment,didContainUserContent,name,type,status,icon{path},homepageId,currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},containsExternalCollaborators,history{createdDate},pageTree(pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includeHomepageTreeVariant){...PageTreeQuery_ptpage,nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{...PageTreeQuery_ptpage,previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},children{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){...PageTreeQuery_ptpage,nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{...PageTreeQuery_ptpage,previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},children{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}\n  rootPageTree:ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){...PageTreeQuery_ptpage,followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id},homepageRootPageTree:ptpage(spaceKey:$spaceKey,status:$ptStatuses)@include(if:$includeHomepageTreeVariant){...PageTreeQuery_ptpage,followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}}fragment PageTreeQuery_ptpage on PTPage{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n  hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}}fragment SpaceHeader_space_3F1fcg on Space{id,key,name,status,icon{path},homepage{id},currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},operations{operation,targetType},containsExternalCollaborators}fragment SpaceOperationsFragment on Space{id,operations{operation,targetType}}"
  }
};
})();

(node as any).hash = "755482d88c7902c5b581142dedb62e7e";

export default node;
